"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connector = exports.URL = exports.Request = exports.Link = void 0;

var _HistoryManager = _interopRequireDefault(require("./HistoryManager"));

var _Request = _interopRequireDefault(require("./Request"));

var _RouteMatcher = _interopRequireDefault(require("./RouteMatcher"));

var _URL = _interopRequireDefault(require("./URL"));

var _Link = require("./Link");

var _Connector = _interopRequireDefault(require("./Connector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeMatcher = new _RouteMatcher.default();
var historyManager = new _HistoryManager.default();
var connector = new _Connector.default(historyManager, routeMatcher);
exports.connector = connector;
var request = new _Request.default(connector);
exports.Request = request;
var url = new _URL.default(connector);
exports.URL = url;
var link = (0, _Link.createLink)(request);
exports.Link = link;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvRmFjYWRlLmpzIl0sIm5hbWVzIjpbInJvdXRlTWF0Y2hlciIsIlJvdXRlTWF0Y2hlciIsImhpc3RvcnlNYW5hZ2VyIiwiSGlzdG9yeU1hbmFnZXIiLCJjb25uZWN0b3IiLCJDb25uZWN0b3IiLCJyZXF1ZXN0IiwiUmVxdWVzdCIsInVybCIsIlVSTCIsImxpbmsiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUVBLElBQU1BLFlBQVksR0FBRyxJQUFJQyxxQkFBSixFQUFyQjtBQUNBLElBQU1DLGNBQWMsR0FBRyxJQUFJQyx1QkFBSixFQUF2QjtBQUNBLElBQU1DLFNBQVMsR0FBRyxJQUFJQyxrQkFBSixDQUFjSCxjQUFkLEVBQThCRixZQUE5QixDQUFsQjs7QUFFQSxJQUFNTSxPQUFPLEdBQUcsSUFBSUMsZ0JBQUosQ0FBWUgsU0FBWixDQUFoQjs7QUFFQSxJQUFNSSxHQUFHLEdBQUcsSUFBSUMsWUFBSixDQUFRTCxTQUFSLENBQVo7O0FBRUEsSUFBTU0sSUFBSSxHQUFHLHNCQUFXSixPQUFYLENBQWIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgSGlzdG9yeU1hbmFnZXIgZnJvbSBcIi4vSGlzdG9yeU1hbmFnZXJcIjtcbmltcG9ydCBSZXF1ZXN0IGZyb20gXCIuL1JlcXVlc3RcIjtcbmltcG9ydCBSb3V0ZU1hdGNoZXIgZnJvbSBcIi4vUm91dGVNYXRjaGVyXCI7XG5pbXBvcnQgVVJMIGZyb20gXCIuL1VSTFwiO1xuaW1wb3J0IHsgY3JlYXRlTGluayB9IGZyb20gXCIuL0xpbmtcIjtcbmltcG9ydCBDb25uZWN0b3IgZnJvbSBcIi4vQ29ubmVjdG9yXCI7XG5cbmNvbnN0IHJvdXRlTWF0Y2hlciA9IG5ldyBSb3V0ZU1hdGNoZXIoKTtcbmNvbnN0IGhpc3RvcnlNYW5hZ2VyID0gbmV3IEhpc3RvcnlNYW5hZ2VyKCk7XG5jb25zdCBjb25uZWN0b3IgPSBuZXcgQ29ubmVjdG9yKGhpc3RvcnlNYW5hZ2VyLCByb3V0ZU1hdGNoZXIpO1xuXG5jb25zdCByZXF1ZXN0ID0gbmV3IFJlcXVlc3QoY29ubmVjdG9yKTtcblxuY29uc3QgdXJsID0gbmV3IFVSTChjb25uZWN0b3IpO1xuXG5jb25zdCBsaW5rID0gY3JlYXRlTGluayhyZXF1ZXN0KTtcblxuZXhwb3J0IHsgbGluayBhcyBMaW5rLCByZXF1ZXN0IGFzIFJlcXVlc3QsIHVybCBhcyBVUkwsIGNvbm5lY3RvciB9O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Facade.js
// module id = 128
// module chunks = 0